
export const EMPTY_RECORD: Record<string, unknown> = {};

export function getRecord(source: Record<string, unknown>, key: string): Record<string, unknown> {
    if(!source[key]) {
        return {};
    }
    return source[key] as Record<string, unknown>;
}

export function castString(source: Record<string, unknown>, key: string): string {
    const value = source[key];
    if (typeof value === "number") {
        return String(value);
    }
    return String(value ?? "").trim();
}

export function formatDuration(seconds: number | null | undefined): string {
    if (seconds === null || seconds === undefined || !Number.isFinite(Number(seconds))) {
        return "-";
    }

    const totalSeconds = Math.max(0, Math.floor(Number(seconds)));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    const parts: string[] = [];
    if (days > 0) {
        parts.push(`${days}d`);
    }
    if (hours > 0 || days > 0) {
        parts.push(`${hours}h`);
    }
    parts.push(`${minutes}m`);

    return parts.join(" ");
}

export function getLocationLabel(location: Record<string, unknown>): string {
    const systemName = castString(location, "systemName");
    const planetName = castString(location, "planetName");
    const cityName = castString(location, "cityName");
    const coordinates = cityName ? `(${location.cityX}, ${location.cityY})` : `(${location.sysX}, ${location.sysY})`;

    return [systemName, planetName, cityName, coordinates].filter(Boolean).join(" / ");
}
